import ContextMenu from '@pinecast/common/ContextMenu';
import Group from '@pinecast/common/Group';
import IconButton from '@pinecast/common/IconButton';
import {LeftArrowSmall, Pinecast} from '@pinecast/common/icons';
import Toggler from '@pinecast/common/Toggler';
import type {LocalizedReactNode} from '@pinecast/common/types';
import {FormattedMessage, useIntl} from '@pinecast/i18n';
import {useColors, useCSS} from '@pinecast/styles';
import {Link as RouterLink} from 'react-router';

const TopHeader = ({
  returnLink,
}: {
  returnLink?: {text: LocalizedReactNode; href: string};
}) => {
  const css = useCSS();
  const designColors = useColors();
  const intl = useIntl();
  return (
    <div
      className={css({
        alignItems: 'center',
        display: 'flex',
        justifyContent: returnLink ? 'space-between' : 'flex-end',
        lineHeight: '16px',
        padding: '8px 0',
      })}
    >
      {returnLink && (
        <RouterLink
          to={returnLink.href}
          className={css({
            color: designColors.contentTextAccent,
            textDecoration: 'none',
            ':hover': {textDecoration: 'underline'},
          })}
        >
          <Group centerChildren spacing={4}>
            <LeftArrowSmall />
            <span>{returnLink.text}</span>
          </Group>
        </RouterLink>
      )}

      <Toggler>
        {({toggle, open, style}) => (
          <ContextMenu
            open={open}
            onClose={() => toggle(false)}
            onSelect={option => {
              switch (option) {
                case 'signout':
                  window.location.assign('/logout');
                  return;
              }
            }}
            options={[
              {
                name: (
                  <FormattedMessage
                    description="Link to the log out page"
                    defaultMessage="Sign out"
                  />
                ),
                slug: 'signout',
              },
            ]}
          >
            <IconButton
              aria-expanded={open}
              aria-haspopup="menu"
              Component={Pinecast}
              iconProps={{size: 28}}
              onClick={toggle}
              style={{...style, color: designColors.contentText, height: 28}}
              title={intl.formatMessage({
                description: 'Label for more options dropdown',
                defaultMessage: 'More options…',
              })}
            />
          </ContextMenu>
        )}
      </Toggler>
    </div>
  );
};

export default TopHeader;
